import { Modal, ModalBody } from "react-bootstrap";
import AnnouncementCreate from "../../components/Announcement/AnnouncementCreate";
import { ChangeEvent, useState } from "react";
import { updateAnnouncement } from "../../api/announcement";
import { updateAnnouncementRequest } from "../../types/announcement";

interface Props {
  onClose: () => void;
  updateItem: updateAnnouncementRequest;
  fetchAnnouncements: () => void;
}

const AnnouncementUpdateContainer = ({ onClose, updateItem, fetchAnnouncements }: Props) => {
  const [item, setItem] = useState<updateAnnouncementRequest>({
    id: updateItem.id,
    title: updateItem.title,
    content: updateItem.content,
    is_published: updateItem.is_published,
    sort_order: updateItem.sort_order,
  });

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = target;
    setItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    try {
      await updateAnnouncement(item);
      fetchAnnouncements();
      onClose();
    } catch (e: any) {
      alert(e.response.data.message);
    }
  };

  return (
    <Modal show onHide={onClose} centered backdrop="static">
      <ModalBody style={{ margin: 0, padding: 0 }}>
        <AnnouncementCreate item={item} onClose={onClose} handleChange={handleChange} handleSubmit={handleUpdate} />
      </ModalBody>
    </Modal>
  );
};

export default AnnouncementUpdateContainer;
